import { Component, OnInit } from '@angular/core';
import {TeamSquadService} from '@modules/team/services/team-squad/team-squad.service';
import {StateService} from '@core/services/state.service';

@Component({
  selector: 'app-team-squad-players',
  templateUrl: './team-squad-players.component.html',
  styleUrls: ['./team-squad-players.component.scss']
})
export class TeamSquadPlayersComponent implements OnInit {

  constructor( public teamSquadService: TeamSquadService) { }

  public ngOnInit() {
    this.teamSquadService.getPlayers();
  }

  public hasPlayers(): boolean {
    return this.teamSquadService.squadPlayers?.length > 0;
  }

}
